module.exports = __webpack_public_path__ + "img/4.ca4013b5.jpg";